function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { UserSettings } from '@leverege/ui-redux';
import { Content, TableV2, Flex, Text, Button, TabPane } from '@leverege/ui-elements';
import { TableModelInitializer } from '@leverege/molten/attributes';
import equal from 'fast-deep-equal';
import { connect } from 'react-redux';
import { ValueCache } from '@leverege/value-cache';
import I18N from '@leverege/i18n';
import BulkResultsTableColumns from "./BulkResultsTableColumns.js";
import { Export } from "../../utils/index.js";
import TablePagination from "./TablePagination.js";
import S from './BulkResultsTable.css';
const {
  t
} = I18N.ns('pairing.bulkPairing.views.BulkResultsTable');
class BulkResultsTable extends React.Component {
  constructor(props) {
    super(props);
    this.tableRef = /*#__PURE__*/React.createRef();
    this.state = {
      tabId: 'error',
      errorColumns: [],
      successColumns: []
    };
    this.resultsCache = new ValueCache();
  }
  componentDidMount() {
    this.setState(BulkResultsTableColumns.determineColumns(this.props));
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      model
    } = this.props;
    if (!equal(model, prevProps.model)) {
      this.setState(BulkResultsTableColumns.determineColumns(this.props)); // eslint-disable-line react/no-did-update-set-state
    }
  }
  getSuccessAndFailures() {
    const {
      data
    } = this.props;
    return this.resultsCache.calc(data => {
      return [data.filter(d => !d?.success), data.filter(d => !!d?.success)];
    }, data);
  }
  renderFooter = ({
    pageCount,
    pageIndex,
    pageSize,
    tableInstance,
    ...rest
  }) => {
    const pages = [];
    for (let n = 0; n < pageCount; n++) {
      pages.push({
        name: n + 1,
        value: n
      });
    }
    const rangeMin = pageIndex * pageSize + 1;
    const rangeMax = Math.min((pageIndex + 1) * pageSize, tableInstance.data.length);
    const totalSize = tableInstance.data.length;
    return /*#__PURE__*/React.createElement(TablePagination, _extends({}, rest, {
      pages: pages,
      rangeMax: rangeMax,
      rangeMin: rangeMin,
      totalSize: totalSize,
      pageSize: pageSize
    }));
  };
  downloadErrorCSV = () => {
    const {
      errorColumns
    } = this.state;
    const [failures] = this.getSuccessAndFailures();
    Export.exportCSV(failures, [...errorColumns.filter(col => col.id !== 'action')], 'pairingFailures.csv');
  };
  render() {
    const {
      onClose,
      unpair,
      fileName,
      parentObjectName,
      settingsPath,
      model,
      parentObjectType
    } = this.props;
    const {
      tabId,
      errorColumns,
      successColumns
    } = this.state;
    const [failures, successes] = this.getSuccessAndFailures();
    const columns = tabId === 'error' ? errorColumns : successColumns;
    return /*#__PURE__*/React.createElement(Content, {
      relative: true,
      style: {
        width: '100vw'
      }
    }, /*#__PURE__*/React.createElement(Content.Header, {
      variant: "formBody"
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "colM"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "formTitle"
    }, t('title')), /*#__PURE__*/React.createElement(Flex, {
      variant: "rowM"
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "rowS",
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "formSubtitle"
    }, t('subtitle')), /*#__PURE__*/React.createElement(Text, {
      variant: "formBody"
    }, fileName)), /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      icon: "fa fa-download",
      onClick: this.downloadErrorCSV
    }, t('downloadErrors'))))), /*#__PURE__*/React.createElement(Content.Area, {
      variant: "formBody",
      style: {
        height: 300,
        paddingBottom: 84,
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: "row",
      justify: "space-between"
    }, /*#__PURE__*/React.createElement(TabPane, {
      activeId: tabId,
      onTabClicked: evt => {
        this.setState({
          tabId: evt.value
        });
      },
      variant: "pairing",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(TabPane.Tab, {
      tabName: t('errorTab', {
        count: failures.length
      }),
      tabId: "error"
    }), /*#__PURE__*/React.createElement(TabPane.Tab, {
      tabName: t('successTab', {
        type: unpair ? 'Unpaired' : 'Paired',
        parentObjectName,
        count: successes.length
      }),
      tabId: "success"
    })), /*#__PURE__*/React.createElement(Button, {
      eventData: {
        settingsPath,
        model,
        parentObjectType
      },
      onClick: BulkResultsTableColumns.onEditTable,
      icon: "fa fa-gear",
      variant: "tertiaryIconic"
    })), /*#__PURE__*/React.createElement(TableV2, {
      variant: "pairingTable",
      tableref: this.tableRef,
      className: S.pairingTable,
      data: tabId === 'error' ? failures : successes,
      columns: columns,
      FooterComponent: this.renderFooter,
      tableInstanceProps: {
        actions: {
          isGotoAllowed: () => false
        }
      },
      paginate: true
    })), /*#__PURE__*/React.createElement(Content.Footer, {
      variant: "formButtons",
      className: S.pairButtons
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "rowMEnd"
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "rowMEnd"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      className: S.submit,
      variant: "primary"
    }, t('completeButton', {
      type: unpair ? 'Unpairing' : 'Pairing'
    }))), /*#__PURE__*/React.createElement(Text, {
      variant: "inputCaptionSmallError"
    }))));
  }
}
export default connect((state, props) => {
  const {
    settingsPath,
    parentObjectType
  } = props;
  let tM = UserSettings.get(state, settingsPath, {
    returnPromise: false
  });
  if (!tM || !tM.columns || tM.columns.length === 0) {
    tM = TableModelInitializer.create(parentObjectType, true);
  }
  return {
    model: tM
  };
})(BulkResultsTable);